import 'whatwg-fetch'
import React from 'react';
import Select from "react-select";
import 'react-select/dist/react-select.css';
import {SkyLightStateless} from "react-skylight";
import {RaisedButton, TextField} from "material-ui";
import {Constants} from "../../../../constants";
import {styles} from "../../../menu/styles";
import RedirectIfNotLogged from "../../../menu/redirect-if-not-logged";
import Header from "../../../header";
import request from "../../../../config/axios-config";
import * as validator from "../../../../general/validators/validator";
import {connect} from "react-redux";
import * as ErrorAction from "../../../../redux/action/error-action";

class AddProductsModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: true,
            error: {
                name: null,
                unit: null,
                price: null
            }
        };
    }

    componentWillUnmount() {
        this.props.hideError();
    }

    componentDidMount() {
        let categoriesOptions = this.props.categories.map((t, i) => {
            return (
                {value: t.id, label: t.name}
            )
        });
        this.setState({
            modalIsOpen: this.state.modalIsOpen,
            categoriesOptions: categoriesOptions,
            name: this.props.name,
            unit: this.props.unit,
            price: this.props.price,
            selectedCategory: this.props.selectedCategory
        });
    }

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
        });
        this.props.onCancel();
    };

    onNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    };

    onUnitChange = (e) => {
        this.setState({
            unit: e.target.value
        });
    };

    onPriceChange = (e) => {
        this.setState({
            price: e.target.value
        });
    };

    onCategoryChange = (val) => {
        this.setState({
            selectedCategory: val
        });
    };

    onSave = (e) => {
        if (!this.validateInput()) {
            return;
        }
        const userJson = JSON.stringify({
            id: this.props.id,
            name: this.state.name.trim(),
            measureUnit: this.state.unit,
            category: this.state.selectedCategory,
            price: this.state.price,
        });

        request({
            url: Constants.SERVER_ENDPOINT + '/product/add',
            method: "post",
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            },
            data: userJson
        }).then(json => {
            this.closeModal();
        }).catch(err => {
            this.props.showError("Salvarea produsului a esuat. Va rog reincercati!");
            this.setState({
                modalIsOpen: true,
            })
        })
    };

    validateInput = () => {
        let error = {};
        let isOk = true;

        if (validator.isEmpty(this.state.name)) {
            error.name = "Lipseste numele";
            isOk = false;
        }
        if (validator.isEmpty(this.state.unit)) {
            error.unit = "Lipseste unitatea de masura";
            isOk = false;
        }
        if (validator.isEmpty(this.state.selectedCategory)) {
            error.selectedCategory = "Lipseste categoria";
            isOk = false;
        }
        if (!validator.isEmpty(this.state.price) && (this.state.price <= 0 || this.state.price === '0' || this.state.price <= 0)) {
            error.price = "Pretul trebuie sa fie numar pozitiv";
            isOk = false;
        }

        this.setState({
            error: error
        });
        return isOk;
    };

    render() {
        return (
            <div>
                <RedirectIfNotLogged/>
                <SkyLightStateless
                    isVisible={this.state.modalIsOpen}
                    dialogStyles={{...styles.defaultDialogStyles, top: '15%'}}
                    onCloseClicked={this.closeModal}
                    onOverlayClicked={this.closeModal}
                    title={<Header title={this.props.title}/>}
                >
                    <div>
                        <form onSubmit={this.onSave}>
                            <table className='table  table-hover table-responsive'>
                                <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>
                                        <TextField
                                            type='text'
                                            hintText={"Numele produsului"}
                                            value={this.state.name}
                                            errorText={this.state.error.name}
                                            onChange={this.onNameChange}
                                        />

                                    </td>
                                </tr>
n
                                <tr>
                                    <td>Unitate Masura</td>
                                    <td>
                                        <TextField
                                            type='text'
                                            hintText={"Unitatea de masura"}
                                            value={this.state.unit}
                                            errorText={this.state.error.unit}
                                            onChange={this.onUnitChange}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>Categorie</td>
                                    <td>
                                        <div>
                                            <Select
                                                ref="stateSelect"
                                                autoFocus options={this.state.categoriesOptions}
                                                simpleValue
                                                clearable={true}
                                                name="selected-state"
                                                disabled={false}
                                                value={this.state.selectedCategory}
                                                onChange={this.onCategoryChange}
                                                searchable={true}/>
                                            <div>
                                                {this.state.error.selectedCategory
                                                && <div style={{fontSize: '12px', color: 'rgb(244, 67, 54)', marginTop: '5px'}}>{this.state.error.selectedCategory}</div>}
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>Price</td>
                                    <td>
                                        <TextField
                                            type='number'
                                            hintText={"Pretul"}
                                            value={this.state.price}
                                            errorText={this.state.error.price}
                                            onChange={this.onPriceChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <RaisedButton
                                            secondary
                                            label={"Renunta"}
                                            onClick={() => this.closeModal()}/>
                                    </td>
                                    <td>
                                        <RaisedButton
                                            primary
                                            label={"Salveaza"}
                                            onClick={() => this.onSave()}/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </SkyLightStateless>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        userDepartment: state.login.user.department,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showError: (text) => dispatch(ErrorAction.showError(text)),
        hideError: () => dispatch(ErrorAction.hideError())
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddProductsModal)